"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_router_1 = require("react-router");
const appConstants_1 = require("../../../../constants/appConstants");
const StyledBox_1 = require("../../../../material-ui-theme/components/styled/StyledBox");
const zustandStore_1 = require("../../../../zustandStore");
const sortWallet_1 = __importDefault(require("./sortWallet"));
const cardStatusOptions = [
    { id: 'active', label: 'Active' },
    { id: 'inactive', label: 'Inactive' },
];
const walletListViewPaths = [/^\/wallet\/team$/, /^\/wallet$/];
const dynamicPathRegex = /^\/wallet\/team\/[\dA-Fa-f-]+\/user\/[\dA-Fa-f-]+$/;
const WalletHeaderActions = () => {
    const location = (0, react_router_1.useLocation)();
    const { userRole } = (0, react_router_1.useLoaderData)();
    const { cards, teamFilter, setTeamFilter, memberFilter, setMemberFilter, cardStatusFilter, setCardStatusFilter, teamOptions, memberOptions, setCurrentWalletPage, setAreFiltersManuallySet, } = (0, zustandStore_1.useZustand)(state => ({
        cards: state.wallet.cards,
        teamFilter: state.wallet.teamFilter,
        setTeamFilter: state.setTeamFilter,
        memberFilter: state.wallet.memberFilter,
        setMemberFilter: state.setMemberFilter,
        cardStatusFilter: state.wallet.cardStatusFilter,
        setCardStatusFilter: state.setCardStatusFilter,
        teamOptions: state.wallet.teamOptions,
        memberOptions: state.wallet.memberOptions,
        setCurrentWalletPage: state.setCurrentWalletPage,
        setAreFiltersManuallySet: state.setAreFiltersManuallySet,
    }));
    const shouldShowFiltersByDefault = walletListViewPaths.some(path => path.test(location.pathname)) || dynamicPathRegex.test(location.pathname);
    return ((0, jsx_runtime_1.jsxs)(StyledBox_1.StyledWalletHeaderBox, { "data-testid": "wallet-header-actions", children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { "data-testid": "wallet-filters", sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: 1,
                }, children: [shouldShowFiltersByDefault ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [[appConstants_1.supportAdmin, appConstants_1.companyAdmin].includes(userRole) ? ((0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "filter-teams", value: teamFilter, onChange: event => {
                                    setAreFiltersManuallySet(true);
                                    setCurrentWalletPage(0);
                                    setTeamFilter(event.target.value);
                                    setMemberFilter('all');
                                }, sx: { minWidth: 150 }, required: true, children: teamOptions?.map(type => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type.id, children: type.label }, type.id))) }, "filterTeams")) : (''), [appConstants_1.supportAdmin, appConstants_1.companyAdmin].includes(userRole) ||
                                (appConstants_1.teamAdmin === userRole && location.pathname.includes('/wallet/team')) ? ((0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "filter-members", value: memberFilter, onChange: event => {
                                    setAreFiltersManuallySet(true);
                                    setCurrentWalletPage(0);
                                    setMemberFilter(event.target.value);
                                }, sx: { minWidth: 150 }, required: true, children: memberOptions.map(type => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type.id, children: type.label }, type.id))) }, "filterMembers")) : ('')] })) : null, (0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "status", value: cardStatusFilter, onChange: event => {
                            setCurrentWalletPage(0);
                            setCardStatusFilter(event.target.value);
                        }, sx: { minWidth: 150 }, required: true, children: cardStatusOptions.map(type => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type.id, children: type.label }, type.id))) }, "status")] }), cards?.length > 0 ? ((0, jsx_runtime_1.jsx)(material_1.Box, { "data-testid": "wallet-sort", sx: {
                    display: 'flex',
                    justifyContent: 'space-evenly',
                }, children: (0, jsx_runtime_1.jsx)(sortWallet_1.default, {}) })) : null] }));
};
exports.default = WalletHeaderActions;
